// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"b50392d8","703":"2d853796"}[chunkId] + ".chunk.js";
};